export type BusinessUnit = 'chipchip' | 'zeami' | 'export' | 'grantt' | 'zarely';

export const BUSINESS_UNITS: { value: BusinessUnit; label: string; color: string }[] = [
  { value: 'chipchip', label: 'ChipChip', color: 'hsl(var(--primary))' },
  { value: 'zeami',    label: 'Zeami',    color: 'hsl(280 65% 55%)' },
  { value: 'export',   label: 'Export',   color: 'hsl(160 65% 40%)' },
  { value: 'grantt',   label: 'Grantt',   color: 'hsl(35 90% 50%)' },
  { value: 'zarely',   label: 'Zarely',   color: 'hsl(340 75% 55%)' },
];

export const BUSINESS_UNIT_LABELS: Record<BusinessUnit, string> = Object.fromEntries(
  BUSINESS_UNITS.map(bu => [bu.value, bu.label])
) as Record<BusinessUnit, string>;

export const DEFAULT_BUSINESS_UNIT: BusinessUnit = 'chipchip';
